document.addEventListener("DOMContentLoaded", () => {
  // 診断ページのみ selectDate() を呼ぶ
  if (document.getElementById("year")) {
    selectDate();
  }

  // nickname が存在するページでのみ表示
  if (document.getElementById("nickname")) {
    searchLocalStorage("nickname");
  }
});

function selectInfo() {
  const inputYear = document.calculation.input_year.value;
  const inputMonth = document.calculation.input_month.value;
  const inputDay = document.calculation.input_day.value;
  const nickname = document.calculation.input_nickname.value;

  const currentDate = new Date();
  const birthDate = new Date(inputYear, inputMonth - 1, inputDay);

  const diff = currentDate - birthDate;
  const months = Math.floor(diff / (86400000 * (365 / 12)));

  let targetUrl = "";
  if (months < 5) {
    targetUrl = "/products/5months";
  } else if (months > 18) {
    targetUrl = "/products/18months";
  } else {
    targetUrl = `/products/${months}months`;
  }

  // localStorage に nickname 保存
  localStorage.setItem("nickname", nickname);

  // 遷移
  window.location.href = targetUrl;

  return false; // フォーム送信はさせない
}

function searchLocalStorage(key) {
  const target = document.getElementById("nickname");
  if (!target) return;

  const value = localStorage.getItem(key);

  // "ちゃん" をつけず、空の場合は "赤"
  if (value && value.length > 0) {
    target.textContent = value;
  } else {
    target.textContent = "赤";
  }
}

function selectDate() {
  const isLeapYear = (year) =>
    (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  const countDatesOfFeb = (year) => (isLeapYear(year) ? 29 : 28);

  const createOption = (id, startNum, endNum, current) => {
    const selectDom = document.getElementById(id);
    let optionDom = "";
    for (let i = startNum; i <= endNum; i++) {
      const selected = i === current ? " selected" : "";
      optionDom += `<option value="${i}"${selected}>${i}</option>`;
    }
    selectDom.innerHTML = ""; // ← 追加：上書き時はクリアする
    selectDom.insertAdjacentHTML("beforeend", optionDom);
  };

  const yearBox = document.getElementById("year");
  const monthBox = document.getElementById("month");
  const dateBox = document.getElementById("date");

  // 5ヶ月前の日付（月末ずれ対応）
  const today = new Date();
  const fiveMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1); // 5ヶ月前の1日
  const lastDayOfTargetMonth = new Date(
    fiveMonthsAgo.getFullYear(),
    fiveMonthsAgo.getMonth() + 1,
    0
  ).getDate();

  // 日部分は「今日の5ヶ月前と同じ日」 or 「その月の末日」の小さい方
  const defaultYear = fiveMonthsAgo.getFullYear();
  const defaultMonth = fiveMonthsAgo.getMonth() + 1;
  const defaultDate = Math.min(today.getDate(), lastDayOfTargetMonth);

  const startYear = new Date().getFullYear() - 2;
  const endYear = new Date().getFullYear() + 1;

  let datesOfYear = [
    31,
    countDatesOfFeb(defaultYear),
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];

  monthBox.addEventListener("change", (e) => {
    dateBox.innerHTML = "";
    const selectedMonth = e.target.value;
    createOption("date", 1, datesOfYear[selectedMonth - 1], 1);
  });

  yearBox.addEventListener("change", (e) => {
    monthBox.innerHTML = "";
    dateBox.innerHTML = "";
    const updatedYear = e.target.value;
    datesOfYear = [
      31,
      countDatesOfFeb(updatedYear),
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];

    createOption("month", 1, 12, 1);
    createOption("date", 1, datesOfYear[0], 1);
  });

  // 初期表示
  createOption("year", startYear, endYear, defaultYear);
  createOption("month", 1, 12, defaultMonth);
  createOption("date", 1, datesOfYear[defaultMonth - 1], defaultDate);
}
